import { makeAutoObservable, runInAction } from "mobx";
import { makePersistable } from "mobx-persist-store";

export default class SplitpaymentStore {
  constructor() {
    makeAutoObservable(this);
    makePersistable(this, {
      name: "SplitpaymentStore",
      properties: ["splitAnalysis"],
    });
  }

  splitAnalysis = {};

  reset = () => {
    this.splitAnalysis = {};
  };

  setSplitAnalysis = async (data) => {
    runInAction(() => {
      this.splitAnalysis = data;
    });
  };
}
